export default {
  heading: 30 as const,
  subtitle: 18 as const,
  body: 16 as const,
  description: 14 as const,
  caption: 12 as const,
};